export function categoryDisplayName(category) {
  return category?.label || category?.name || ''
}

export function categoryPathFromCatalog(categoryId, catalog = []) {
  if (!categoryId || !Array.isArray(catalog) || !catalog.length) {
    return ''
  }

  const byId = new Map(catalog.map((category) => [Number(category.id), category]))
  const parts = []
  const seen = new Set()
  let current = byId.get(Number(categoryId))

  while (current && !seen.has(current.id)) {
    seen.add(current.id)
    const name = categoryDisplayName(current)
    if (name) {
      parts.unshift(name)
    }
    current = current.parent_id ? byId.get(Number(current.parent_id)) : null
  }

  return parts.join(' › ')
}

export function categoryDisplayPath(category, catalog = []) {
  const directPath = categoryFullPath(category)
  if (directPath) {
    return directPath
  }

  return categoryPathFromCatalog(category?.id, catalog)
}

export function categoryFullPath(category) {
  const label = category?.label || ''
  if (label) {
    return label.replace(/\s*>\s*/g, ' › ')
  }

  return category?.name || ''
}

export function categoryShortName(category) {
  if (category?.name) {
    return category.name
  }

  const label = category?.label || ''
  const parts = label.split(' > ').map((part) => part.trim()).filter(Boolean)
  return parts[parts.length - 1] || label
}

export function categoryBreadcrumb(category) {
  const label = category?.label || ''
  const parts = label.split(' > ').map((part) => part.trim()).filter(Boolean)

  if (parts.length <= 1) {
    return category?.group_name || ''
  }

  return parts.slice(0, -1).join(' › ')
}

export function assignedCategoriesFromObject(object) {
  if (Array.isArray(object?.categories) && object.categories.length) {
    return object.categories
  }

  if (Array.isArray(object?.categories_data)) {
    return object.categories_data.filter((item) => item.checked)
  }

  return []
}

export function formatObjectCategoryLabels(object, separator = ', ') {
  return assignedCategoriesFromObject(object)
    .map(categoryDisplayName)
    .filter(Boolean)
    .join(separator)
}

export function groupCategoriesByName(categories, fallbackGroupName = '') {
  return categories.reduce((groups, category) => {
    const groupName = category.group_name || fallbackGroupName
    groups[groupName] = groups[groupName] || []
    groups[groupName].push(category)
    return groups
  }, {})
}
